<ion-grid>
  <ion-row>
    <ion-col size="3">



      <ion-card style="height: 100%" *ngIf="sajatIntezmeny">
        <ion-card-header>
          <ion-card-title><span style="vertical-align: -webkit-baseline-middle;">Szűrő</span>
          </ion-card-title>
        </ion-card-header>
        <ion-card-content
          style="padding-top:10px !important; padding-left:10px !important; padding-right:10px !important; padding-bottom: 0 !important;">
          <ng-container>

            <ion-input
              label="Név"
              label-placement="stacked"
              fill="outline"
              placeholder=""
              [(ngModel)]="szuro.nev"
              (keyup.enter)="szures()"
            ></ion-input><br>
            <ion-input label="Oktatási azonosító" label-placement="stacked" fill="outline"
              placeholder=""
              [(ngModel)]="szuro.oktazon"
              (keyup.enter)="szures()"
            ></ion-input><br>
            <ion-input
              label="Felhasználónév"
              label-placement="stacked"
              fill="outline"
              placeholder=""
              [(ngModel)]="szuro.adid"
              (keyup.enter)="szures()"
            ></ion-input>
            <ion-grid>
              <ion-row>
                <ion-col size="6">
                  <ion-button color="primary" expand="block" (click)="szures()">
                    <ion-icon slot="start" name="search"></ion-icon>
                    Keresés
                  </ion-button>
                </ion-col>
                <ion-col size="6">
                  <ion-button color="dark" expand="block" (click)="szuresTorles()">
                    <ion-icon slot="start" name="close"></ion-icon>
                    Törlés
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>

          </ng-container>
        </ion-card-content>
      </ion-card>



    </ion-col>
    <ion-col size="9">

      <div style="margin-top: 10px;">
        <ion-button color="primary" (click)="ujAllomany()">
          <ion-icon slot="start" name="add"></ion-icon>
          Új
        </ion-button>

        <!--
          Nyomtatható jelenléti ívek. A pedagógus/egyéb bontás a MUNKAKÖR alapján
          történik (a jogkör rendszer-jogosultság, abból nem következik a beosztás),
          és a munkakör az íven oszlopként látszik is, hogy ellenőrizhető legyen.
        -->
        <ion-button fill="outline" color="medium" (click)="jelenletiIv('tanar')"
                    title="Jelenléti ív – csak a pedagógus munkakörűek">
          <ion-icon slot="start" name="print-outline"></ion-icon>Pedagógusok
        </ion-button>
        <ion-button fill="outline" color="medium" (click)="jelenletiIv('egyeb')"
                    title="Jelenléti ív – a nem pedagógus munkakörűek">
          <ion-icon slot="start" name="print-outline"></ion-icon>Egyéb dolgozók
        </ion-button>
        <ion-button fill="outline" color="medium" (click)="jelenletiIv('mind')"
                    title="Jelenléti ív – minden dolgozó">
          <ion-icon slot="start" name="print-outline"></ion-icon>Mindenki
        </ion-button>

        <ion-item lines="none" style="--min-height:auto">
          <ion-checkbox slot="start" [(ngModel)]="kilepettekIs" (ionChange)="getAllomany()"></ion-checkbox>
          <ion-label style="font-size:.85rem">Kilépettek is</ion-label>
        </ion-item>
        <span style="margin-left:10px;color:#666">{{ allomanySzurt?.length || 0 }} munkatárs</span>
      </div>
      <ng-container>
        <ngx-datatable #allomanyTable (select)="onSelect($event)"
          class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz selectable checkbox-selection"
          [rows]="allomanySzurt" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="10"
          [footerHeight]="50"
          [count]="allomanySzurt?.length || 0"
          [selected]="selected" [selectionType]="SelectionType.checkbox" [rowClass]="getRowClass" [sorts]="[
  { prop: 'created_at', dir: 'desc' },
  { prop: 'updated_at', dir: 'desc' },
  { prop: 'priority', dir: 'desc' },
  { prop: 'deadline', dir: 'desc' }
]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
          <ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false"
            [resizeable]="false">
            <ng-template ngx-datatable-header-template let-value="value" let-allRowsSelected="allRowsSelected"
              let-selectFn="selectFn">
              <input type="checkbox" [checked]="allRowsSelected" (change)="selectFn(!allRowsSelected)" />
            </ng-template>
            <ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected"
              let-onCheckboxChangeFn="onCheckboxChangeFn">
              <input type="checkbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Név" prop="created_at">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Név</b>
              <app-profilkep class="nevsor-kep" tipus="dolgozo" [azon]="row.adid || row.email" [nev]="row.viselt_vez + ' ' + row.viselt_ker"></app-profilkep>
              {{ row.viselt_vez }} {{ row.viselt_ker }}
              <!-- A kilépett munkatárs itt még látszik (ez az állomány karbantartása),
                   a többi képernyőn viszont már nem jelenik meg. -->
              <ion-badge color="medium" *ngIf="kilepett(row)"
                         title="A jogviszony lezárult – a többi képernyőn már nem jelenik meg">kilépett</ion-badge>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Jogkör">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Jogkör</b>

            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Feladatkör" prop="szul_hely">
            <ng-template let-value="value" ngx-datatable-cell-template>
              <b class="mobil">Feladatkör</b>
              {{ value }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Oktatási azonosító" prop="oktazon">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Oktatási azonosító</b>
              <span *ngIf="value">{{ value }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Felhasználónév" prop="adid">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Felhasználónév</b>
              {{ value }}
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="Műveletek">
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <b class="mobil">Műveletek</b>
              <ion-button color="secondary" size="small" style="margin-top:0" title="Módosítás" (click)="initModal(row)">
                <ion-icon slot="icon-only" name="create"></ion-icon>

              </ion-button>
              <ion-button color="danger" size="small" style="margin-top:0" title="Törlés" (click)="allomanyTorol(row)">
                <ion-icon slot="icon-only" name="trash"></ion-icon>

              </ion-button>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </ng-container>



    </ion-col>
  </ion-row>
</ion-grid>









<ion-modal class="nagy" style="z-index: 1000" #uzenetmodal trigger="uzenet">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-button (click)="cancel()">Mégse</ion-button>
        </ion-buttons>
        <ion-title>Új állomány</ion-title>
        <ion-buttons slot="end">
          <ion-button style="background: white; border-radius: 5px" (click)="confirm(1)" [strong]="true" shape="round"
            color="secondary">Mentés</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">

      <ion-segment value="1" color="primary" [scrollable]="true" [(ngModel)]="segment">
        <ion-segment-button value="1" layout="icon-start">
          <ion-label>Személyes</ion-label>
          <ion-icon name="person"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="2" layout="icon-start">
          <ion-label>Cím és elérhetőség</ion-label>
          <ion-icon name="call"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="3" layout="icon-start">
          <ion-label>Munkaügy</ion-label>
          <ion-icon name="briefcase"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="4" layout="icon-start">
          <ion-label>Belépés</ion-label>
          <ion-icon name="log-in"></ion-icon>
        </ion-segment-button>
        <ion-segment-button value="5" layout="icon-start">
          <ion-label>Végzettség / Képesítés</ion-label>
          <ion-icon name="school"></ion-icon>
        </ion-segment-button>
      </ion-segment>
      <hr>
      <!-- A csillagozott mezők listáját az ADATBÁZIS adja (NOT NULL, alapérték nélkül),
           ugyanaz a forrás, ami a mentést is engedi vagy tiltja – így a kettő nem
           tud elcsúszni egymástól. -->
      <ion-note color="medium" class="allomany-editor-note" *ngIf="vanKotelezoMezo">
        A <b>*</b>-gal jelölt mezők kitöltése kötelező, enélkül a mentés nem indul el.
      </ion-note>

      <form [formGroup]="form">
      <ion-grid>
        <ion-row *ngIf="segment=='1'">
          <!--table style="width: 100%;">
      <thead>

      </thead>
      <tbody>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
        <tr>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
          <td><ion-input label="Családi név" label-placement="stacked" fill="outline" placeholder=""></ion-input></td>
        </tr>
      </tbody>
    </table-->
          <ion-col>
            <ion-input label="Előtag{{ cs('viselt_elo') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="viselt_elo">
              <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
            </ion-input><br>
            <ion-input label="Születési előtag{{ cs('szul_elo') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="szul_elo">
              <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
            </ion-input><br>
            <ion-input label="Anyja leánykori előtag{{ cs('anya_elo') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="anya_elo">
              <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon></ion-input><br>
            <!--ion-input label="Születési hely" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="balloon" aria-hidden="true"></ion-icon></ion-input-->
                <div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-notch sc-ion-input-md">
                    <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési hely</div>
                  </div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="label-text-wrapper sc-ion-input-md">
                  <div class="label-text sc-ion-input-md">Születési hely</div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  <ion-icon name="balloon" aria-hidden="true"></ion-icon>
                  <ionic-selectable 
                        
                        item-content
                        [items]="telepules"
                        formControlName="szul_hely"
                        itemValueField="id"
                        itemTextField="full_name_irsz"
                        [canSearch]="true"
                        [canClear]="true"
                        closeButtonText="Mégse"
                        [searchFailText]="'Nincs találat'"
                        [searchPlaceholder]="'Keresés'"
                        [hasInfiniteScroll]="false"
                        clearButtonText="Visszaállítás"
                      >
                      </ionic-selectable>
                </div>
              </label>
            </div>
            <br>
            <!--ion-input label="Anyanyelv" label-placement="stacked" fill="outline" placeholder=""><ion-icon slot="start"
                name="globe" aria-hidden="true"></ion-icon></ion-input-->
                <div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-notch sc-ion-input-md">
                    <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Anyanyelv</div>
                  </div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="label-text-wrapper sc-ion-input-md">
                  <div class="label-text sc-ion-input-md">Anyanyelv</div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  <ion-icon name="globe" aria-hidden="true"></ion-icon>
                  <ionic-selectable 
                        
                        item-content
                        [items]="allampolgar"
                        formControlName="anyanyelv"
                        itemValueField="id"
                        itemTextField="nev"
                        [canSearch]="true"
                        [canClear]="true"
                        closeButtonText="Mégse"
                        [searchFailText]="'Nincs találat'"
                        [searchPlaceholder]="'Keresés'"
                        [hasInfiniteScroll]="true"
                        clearButtonText="Visszaállítás"
                      >
                      </ionic-selectable>
                </div>
              </label>
            </div>
                <br>
            <ion-input label="Oktatási azonosító{{ cs('oktazon') }}" label-placement="stacked" fill="outline" placeholder="" maxlength="11" formControlName="oktazon"
              minlength="11"><ion-icon slot="start" name="business" aria-hidden="true"></ion-icon></ion-input><br>
            <!-- A belépési azonosító felvételkor dől el, és utána nem szerkeszthető:
                 az egész rendszer ezzel hivatkozik a kollégára. Megváltoztatni csak a
                 „Cím és elérhetőség" fülön található átvezetéssel lehet. -->
            <ion-input *ngIf="activeAllomany?.adid" label="Belépési azonosító (felhasználónév)"
              label-placement="stacked" fill="outline" [readonly]="true"
              [value]="activeAllomany.adid"><ion-icon slot="start" name="key" aria-hidden="true"></ion-icon></ion-input>
            <ion-note *ngIf="activeAllomany?.adid" color="medium" style="display:block;margin:2px 0 10px">
              Nem szerkeszthető. E-mail cím változásakor a „Cím és elérhetőség" fülön vezethető át.
            </ion-note>
            <!--ion-input label="Igazolvány típus" label-placement="stacked" fill="outline" placeholder=""></ion-input-->
            <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Igazolvány típus{{ cs('ig_tipus') }}" formControlName="ig_tipus"
              label-placement="stacked" fill="outline">
              <ion-icon slot="start" name="bookmarks" aria-hidden="true"></ion-icon>
              <ion-select-option value="Személyi igazolvány">Személyi igazolvány</ion-select-option>
              <ion-select-option value="Ideiglenes személyi igazolvány">Ideiglenes személyi igazolvány</ion-select-option>
              <ion-select-option value="Jogosítvány">Jogosítvány</ion-select-option>
              <ion-select-option value="Útlevél">Útlevél</ion-select-option>
              <ion-select-option value="Tartózkodási / lakcímet igazoló engedély">Tartózkodási / lakcímet igazoló engedély</ion-select-option>
            </ion-select>
          </ion-col>
          <ion-col>
            <ion-input label="Családi név{{ cs('viselt_vez') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="viselt_vez">
              <ion-icon slot="start" name="people" aria-hidden="true"></ion-icon>
            </ion-input><br>
            <ion-input label="Születési családi név{{ cs('szul_vez') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="szul_vez"><ion-icon
                slot="start" name="people" aria-hidden="true"></ion-icon></ion-input><br>
            <ion-input label="Anyja családi név{{ cs('anya_vez') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="anya_vez"><ion-icon
                slot="start" name="people" aria-hidden="true"></ion-icon></ion-input><br>
                <ion-input label="Születési idő{{ cs('szul_datum') }}" label-placement="stacked" fill="outline" placeholder="" type="date" max="3000-12-31" formControlName="szul_datum"><ion-icon slot="start"
                  name="time" aria-hidden="true"></ion-icon></ion-input><br>

            <ion-modal [keepContentsMounted]="true" >
              <ng-template>
                <ion-datetime style="border: 1px solid;" id="datetime" [firstDayOfWeek]="1" presentation="date" [formatOptions]="{
                  date: {
                    year: 'numeric',
                    month: 'long',
                    day: '2-digit',
                  },
                }"></ion-datetime>
              </ng-template>
            </ion-modal>
            <!--ion-input label="Állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
                <div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-notch sc-ion-input-md">
                    <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Állampolgárság</div>
                  </div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="label-text-wrapper sc-ion-input-md">
                  <div class="label-text sc-ion-input-md">Állampolgárság</div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  <ion-icon name="planet" aria-hidden="true"></ion-icon>
                  <ionic-selectable 
                        
                        item-content
                        [items]="allampolgar"
                        formControlName="allampolgar1"
                        itemValueField="id"
                        itemTextField="nev"
                        [canSearch]="true"
                        [canClear]="true"
                        closeButtonText="Mégse"
                        [searchFailText]="'Nincs találat'"
                        [searchPlaceholder]="'Keresés'"
                        [hasInfiniteScroll]="true"
                        clearButtonText="Visszaállítás"
                      >
                      </ionic-selectable>
                </div>
              </label>
            </div>
                <br>
                <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Nem{{ cs('nem') }}"
                label-placement="stacked" fill="outline" formControlName="nem">
                <ion-icon slot="start" name="male-female" aria-hidden="true"></ion-icon>
                <ion-select-option value="1">Férfi</ion-select-option>
                <ion-select-option value="0">Nő</ion-select-option>
                <ion-select-option value="2">Egyéb</ion-select-option>
              </ion-select><br>
            <ion-input label="Igazolvány szám{{ cs('ig_szam') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="ig_szam"><ion-icon
                slot="start" name="id-card" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <ion-col>
            <ion-input label="Utónév{{ cs('viselt_ker') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="viselt_ker"><ion-icon slot="start"
                name="person" aria-hidden="true" ></ion-icon></ion-input><br>
            <ion-input label="Születési utónév{{ cs('szul_ker') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="szul_ker"><ion-icon
                slot="start" name="person" aria-hidden="true"></ion-icon></ion-input><br>
            <ion-input label="Anyja utónév{{ cs('anya_ker') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="anya_ker"><ion-icon
                slot="start" name="person" aria-hidden="true"></ion-icon></ion-input><br>
            <!--ion-input label="Születési ország" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="earth" aria-hidden="true"></ion-icon></ion-input-->
                <div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-notch sc-ion-input-md">
                    <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Születési ország</div>
                  </div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="label-text-wrapper sc-ion-input-md">
                  <div class="label-text sc-ion-input-md">Születési ország</div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  <ion-icon name="globe" aria-hidden="true"></ion-icon>
                  <ionic-selectable 
                        
                        item-content
                        [items]="orszag"
                        formControlName="szul_orszag"
                        itemValueField="id"
                        itemTextField="nev"
                        [canSearch]="true"
                        [canClear]="true"
                        closeButtonText="Mégse"
                        [searchFailText]="'Nincs találat'"
                        [searchPlaceholder]="'Keresés'"
                        [hasInfiniteScroll]="true"
                        clearButtonText="Visszaállítás"
                      >
                      </ionic-selectable>
                </div>
              </label>
            </div>
                <br>
            <!--ion-input label="Második állampolgárság" label-placement="stacked" fill="outline" placeholder=""><ion-icon
                slot="start" name="planet" aria-hidden="true"></ion-icon></ion-input-->
                <div
                class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
                <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                  <div class="input-outline-container sc-ion-input-md">
                    <div class="input-outline-start sc-ion-input-md"></div>
                    <div class="input-outline-notch sc-ion-input-md">
                      <div class="notch-spacer sc-ion-input-md" aria-hidden="true">Második állampolgárság</div>
                    </div>
                    <div class="input-outline-end sc-ion-input-md"></div>
                  </div>
                  <div class="label-text-wrapper sc-ion-input-md">
                    <div class="label-text sc-ion-input-md">Második állampolgárság</div>
                  </div>
                  <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                    <ion-icon name="planet" aria-hidden="true"></ion-icon>
                    <ionic-selectable 
                        
                        item-content
                        [items]="allampolgar"
                        formControlName="allampolgar2"
                        itemValueField="id"
                        itemTextField="nev"
                        [canSearch]="true"
                        [canClear]="true"
                        closeButtonText="Mégse"
                        [searchFailText]="'Nincs találat'"
                        [searchPlaceholder]="'Keresés'"
                        [hasInfiniteScroll]="true"
                        clearButtonText="Visszaállítás"
                      >
                      </ionic-selectable>
                  </div>
                </label>
              </div>
                <br>
            <ion-input label="TAJ-szám{{ cs('taj') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="taj"><ion-icon slot="start"
                name="medical" aria-hidden="true"></ion-icon></ion-input><br>
            <ion-input label="Adóazonosító jel{{ cs('adoazon') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="adoazon"><ion-icon
                slot="start" name="briefcase" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
        </ion-row>



        <ion-row *ngIf="segment=='2'">
          <ion-col>
            <ion-input label="Értesítési telefonszám{{ cs('telefonszam') }}" label-placement="stacked" fill="outline" placeholder="" type="tel" formControlName="telefonszam"><ion-icon slot="start"
              name="call" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <ion-col>
            <ion-input type="email" label="Értesítési e-mail cím{{ cs('email') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="email"><ion-icon slot="start"
              name="mail" aria-hidden="true"></ion-icon>
             
                <ion-icon color="danger" slot="icon-only" name="close-circle" aria-hidden="true" slot="end"></ion-icon>
              
            </ion-input>
          </ion-col>
        </ion-row>
        <!-- LAKCÍMEK.
             Itt korábban egy üres, működésképtelen táblázat állt („Új" gombbal, ami
             semmit nem csinált), miközben az adatbázis mind a tizenkét címmezőt
             tárolja. A munkatárs lakcímét így sehol nem lehetett rögzíteni. -->
        <ion-row *ngIf="segment=='2'">
          <ion-col size="12"><h2 style="margin-bottom:0">Állandó lakcím</h2></ion-col>
        </ion-row>
        <ion-row *ngIf="segment=='2'">
          <ion-col size="12" size-md="4">
            <ion-input label="Irányítószám{{ cs('all_cim_irsz') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_irsz"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Település{{ cs('all_cim_telepules') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_telepules"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Közterület neve{{ cs('all_cim_kozter') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_kozter"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Közterület jellege{{ cs('all_cim_kozter_jelleg') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_kozter_jelleg"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Házszám{{ cs('all_cim_hsz') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_hsz"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Pontosítás (emelet, ajtó){{ cs('all_cim_pontositas') }}" label-placement="stacked" fill="outline"
              formControlName="all_cim_pontositas"></ion-input>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="segment=='2'">
          <ion-col size="12" style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
            <h2 style="margin-bottom:0">Tartózkodási cím</h2>
            <ion-button size="small" fill="outline" color="medium" (click)="tartCimAzAllandobol()">
              <ion-icon slot="start" name="copy-outline"></ion-icon>
              Megegyezik az állandóval
            </ion-button>
          </ion-col>
        </ion-row>
        <ion-row *ngIf="segment=='2'">
          <ion-col size="12" size-md="4">
            <ion-input label="Irányítószám{{ cs('tart_cim_irsz') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_irsz"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Település{{ cs('tart_cim_telepules') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_telepules"><ion-icon slot="start" name="home" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Közterület neve{{ cs('tart_cim_kozter') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_kozter"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Közterület jellege{{ cs('tart_cim_kozter_jelleg') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_kozter_jelleg"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Házszám{{ cs('tart_cim_hsz') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_hsz"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Pontosítás (emelet, ajtó){{ cs('tart_cim_pontositas') }}" label-placement="stacked" fill="outline"
              formControlName="tart_cim_pontositas"></ion-input>
          </ion-col>
        </ion-row>

        <!-- E-MAIL VÁLTOZÁS ÁTVEZETÉSE.
             A belépési azonosító az e-mail címből keletkezett; ha a cím megváltozik,
             az azonosító a régin marad, és a kolléga nem tud belépni. Kézzel átírni
             nem lehet: minden hivatkozás (óra, értékelés, kinevezés) elárvulna. -->
        <ion-row *ngIf="segment=='2' && migSzukseges">
          <ion-col size="12">
            <ion-card color="warning">
              <ion-card-header>
                <ion-card-title style="font-size:16px">A belépési azonosító még a régi e-mail cím</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                <p style="margin:0 0 8px">
                  Jelenlegi azonosító: <b>{{ migRegi }}</b> → új cím: <b>{{ migUj }}</b>.
                  Amíg nincs átvezetve, a kolléga az <b>új</b> címével nem tud belépni.
                  Az átvezetés minden hivatkozást átír (óra, naplózás, értékelés,
                  tantárgyfelosztás, kinevezés, üzenetek), egyetlen tranzakcióban.
                </p>
                <ion-button size="small" fill="outline" color="dark" [disabled]="migFut"
                  (click)="migElonezet()">Mi változna?</ion-button>
                <ion-button size="small" color="danger" [disabled]="migFut || !migTalalatok"
                  (click)="migAtvezet()">Átvezetés</ion-button>

                <div *ngIf="migTalalatok" style="margin-top:10px">
                  <div *ngIf="!migTalalatok.length">A régi azonosító sehol nem szerepel – nincs mit átvezetni.</div>
                  <div *ngIf="migTalalatok.length">
                    <b>{{ migOsszes }}</b> hivatkozás vezetődik át, {{ migTalalatok.length }} helyen találtuk meg:
                    <ul style="margin:6px 0 0 0;padding:0;list-style:none">
                      <li *ngFor="let t of migTalalatok" style="margin:2px 0">
                        <ion-checkbox [checked]="t.valasztva" [disabled]="t.kotelezo"
                          (ionChange)="migPipa(t)" labelPlacement="end" justify="start">
                          <span [style.opacity]="t.valasztva ? 1 : 0.55">
                            {{ t.tabla }}.{{ t.oszlop }} — {{ t.db }} sor
                            <b *ngIf="t.kotelezo"> (kötelező)</b>
                          </span>
                        </ion-checkbox>
                        <ion-note *ngIf="t.indok" color="dark" style="display:block;margin-left:34px">
                          ⚠ {{ t.indok }}
                        </ion-note>
                      </li>
                    </ul>
                    <ion-note color="dark" style="display:block;margin-top:8px">
                      A keresés szövegre illeszt, ezért olyan oszlopot is megtalálhat, ahol az
                      azonosító mást jelent. A megjelölt sorok alapból nincsenek bepipálva –
                      nézd át a listát, mielőtt átvezeted.
                    </ion-note>
                  </div>
                </div>
                <ion-note color="dark" style="display:block;margin-top:10px">
                  A belépési rendszerben (Microsoft / Keycloak) is az <b>új</b> címnek kell
                  szerepelnie — azt ez a művelet nem állítja át.
                </ion-note>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>



        <ion-row *ngIf="segment=='3'" >
          <ion-col>
            <ion-input label="Munkakör{{ cs('munkakor') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="munkakor"><ion-icon slot="start"
              name="briefcase" aria-hidden="true"></ion-icon></ion-input><br>
          </ion-col>
          <ion-col>
            <ion-select interface="popover" placeholder="" label="Jogviszony{{ cs('munkaviszony') }}" formControlName="munkaviszony"
                label-placement="stacked" fill="outline">
                <ion-icon slot="start" name="ribbon" aria-hidden="true"></ion-icon>
                <ion-select-option value="0">Munkaviszony - határozott időre</ion-select-option>
                <ion-select-option value="1">Munkaviszony - határozatlan időre</ion-select-option>
                <ion-select-option value="2">Köznevelési foglalkoztatott - határozott időre</ion-select-option>
                <ion-select-option value="3">Köznevelési foglalkoztatott - határozatlan időre</ion-select-option>
                <ion-select-option value="4">Közalkalmazott - határozott időre</ion-select-option>
                <ion-select-option value="5">Közalkalmazott - határozatlan időre</ion-select-option>
                <ion-select-option value="6">Polgári - megbízás</ion-select-option>
                <ion-select-option [value]="ORAADO_JOGVISZONY">Óraadó - megbízás</ion-select-option>
                <ion-select-option value="8">Egyházi szolgálat</ion-select-option>
                <ion-select-option value="9">Egyéni/társas vállalkozó</ion-select-option>
              </ion-select><br>
          </ion-col>
          <ion-col>

            <ion-select aria-label="Igazolvány típus" interface="popover" placeholder="" label="Pedagógus fokozat{{ cs('ped_fokozat') }}"
            label-placement="stacked" fill="outline" formControlName="ped_fokozat">
            <ion-icon slot="start" name="school" aria-hidden="true"></ion-icon>
            <ion-select-option value="0">Nincs fokozat</ion-select-option>
            <ion-select-option value="1">Gyakornok</ion-select-option>
            <ion-select-option value="2">Pedagógus 1</ion-select-option>
            <ion-select-option value="3">Pedagógus 2</ion-select-option>
            <ion-select-option value="3">Mesterpedagógus</ion-select-option>
            <ion-select-option value="3">Kutatótanár</ion-select-option>
          </ion-select><br>
          </ion-col>
        </ion-row>
        <!-- VÉGZETTSÉG. Az adatbázis egyetlen szabadszöveges mezőt tárol; a
             tételes képesítés-nyilvántartás (oklevél, szak, intézmény, dátum)
             még nem készült el, ezért itt egy mező áll. -->
        <ion-row *ngIf="segment=='5'">
          <ion-col size="12">
            <ion-textarea label="Végzettség / képesítés{{ cs('vegzettseg') }}" label-placement="stacked"
              fill="outline" [autoGrow]="true" rows="3" formControlName="vegzettseg"></ion-textarea>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="segment=='3'">
          <ion-col>
            <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            
      <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="vezeto">
        Vezető beosztás</ion-checkbox>
          </div>
        </label>
      </div><br>
      
            <ion-input label="Alkalmazás kezdete{{ cs('jogviszony_kezd') }}" label-placement="stacked" fill="outline" placeholder="" type="date" max="3000-12-31" formControlName="jogviszony_kezd"><ion-icon slot="start"
              name="person-circle" aria-hidden="true"></ion-icon></ion-input><br>
              <div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  
            <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="ttf">
              Tantárgyfelosztásban megjelenik</ion-checkbox>
                </div>
              </label>
            </div>
          </ion-col>
          <ion-col>
            <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            
      <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="csok_mi">
        Csökkentett munkaidő</ion-checkbox>
          </div>
        </label>
      </div><br>
            
            <!--  ÓRAADÓ (megbízás): nincs munkaidő-arány és kötött munkaidő – csak a megtartott órák
                  számítanak. Az arány helyett a szerződés szerinti heti óraszám, és a díj alapja,
                  az óradíj (megtartott órák × óradíj). -->
            <ng-container *ngIf="!oraado">
            <ion-input label="Részmunkaidő aránya{{ cs('reszm_arany') }}" label-placement="stacked" fill="outline" placeholder="" type="number" formControlName="reszm_arany"><ion-icon slot="start"
              name="briefcase" aria-hidden="true"></ion-icon></ion-input>
              <br>
            </ng-container>
            <ng-container *ngIf="oraado">
            <ion-input label="Heti óraszám (megbízás){{ cs('heti_oraszam') }}" label-placement="stacked" fill="outline" placeholder="pl. 6" type="number" min="0" step="0.5" formControlName="heti_oraszam"
              helperText="Óraadónál nincs munkaidő-arány és kötött munkaidő: csak a megtartott órák számítanak."><ion-icon slot="start"
              name="time" aria-hidden="true"></ion-icon></ion-input>
              <br>
            <ion-input label="Megbízási óradíj (Ft / óra){{ cs('megbizasi_oradij') }}" label-placement="stacked" fill="outline" placeholder="" type="number" min="0" formControlName="megbizasi_oradij"
              helperText="A díj: megtartott órák × óradíj. Ha a Bérek és pótlékok képernyőn van óradíj, az az irányadó."><ion-icon slot="start"
              name="cash" aria-hidden="true"></ion-icon></ion-input>
              <br>
            </ng-container>
              <ion-input label="Alkalmazás vége{{ cs('jogviszony_vege') }}" label-placement="stacked" fill="outline" placeholder="" type="date" max="3000-12-31" formControlName="jogviszony_vege"><ion-icon slot="start"
                name="person-circle" aria-hidden="true"></ion-icon></ion-input><br>
          </ion-col>
          <ion-col>
            <div
        class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
        <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
          <div class="input-outline-container sc-ion-input-md">
            <div class="input-outline-start sc-ion-input-md"></div>
            <div class="input-outline-end sc-ion-input-md"></div>
          </div>
          <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
            
      <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="utazo_gyogyped">
        Utazó gyógypedagógus</ion-checkbox>
          </div>
        </label>
      </div><br>
          </ion-col>
          <ion-col>
            <div
            class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
            <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
              <div class="input-outline-container sc-ion-input-md">
                <div class="input-outline-start sc-ion-input-md"></div>
                <div class="input-outline-end sc-ion-input-md"></div>
              </div>
              <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                
          <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="foallas">
            Főállás</ion-checkbox>
              </div>
            </label>
          </div><br>
            <ion-input label="Szerződésszám{{ cs('szszam') }}" label-placement="stacked" fill="outline" placeholder="" formControlName="szszam"><ion-icon slot="start"
              name="briefcase" aria-hidden="true"></ion-icon></ion-input><br><div
              class="sc-ion-input-md-h sc-ion-input-md-s md label-floating input-fill-outline input-label-placement-stacked hydrated">
              <label class="input-wrapper sc-ion-input-md" for="ion-input-szi">
                <div class="input-outline-container sc-ion-input-md">
                  <div class="input-outline-start sc-ion-input-md"></div>
                  <div class="input-outline-end sc-ion-input-md"></div>
                </div>
                <div class="native-wrapper sc-ion-input-md sc-ion-input-md-s">
                  
            <ion-checkbox labelPlacement="start" style="width: 100%; height: 100%;" formControlName="tartos_tavollet">
             Tartós távollét</ion-checkbox>
                </div>
              </label>
            </div><br>
          </ion-col>
        </ion-row>
        <!--  MUNKÁBA JÁRÁS (saját gépkocsi). A napi km eddig is számolt (Munkatársak › Riportok,
              „Utazás térítése”), csak sehol nem lehetett beállítani. Az útvonal, az eszköz és a
              rendszám a havi „MUNKÁBAJÁRÁS ELSZÁMOLÁSA” nyomtatvány fejlécébe kerül; a Ft/km
              díj intézményi (Admin › Dokumentumok). -->
        <ion-row *ngIf="segment=='3'">
          <ion-col size="12"><h2 style="margin-bottom:0">Munkába járás</h2></ion-col>
        </ion-row>
        <ion-row *ngIf="segment=='3'">
          <ion-col size="12" size-md="3">
            <ion-input label="Napi km (oda-vissza){{ cs('benzinkm') }}" label-placement="stacked" fill="outline"
              type="number" min="0" step="0.1" formControlName="benzinkm"><ion-icon slot="start" name="car" aria-hidden="true"></ion-icon></ion-input>
          </ion-col>
          <ion-col size="12" size-md="4">
            <ion-input label="Útvonal{{ cs('utazas_utvonal') }}" label-placement="stacked" fill="outline"
              placeholder="pl. Vác – Göd – Vác" maxlength="255" formControlName="utazas_utvonal"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="3">
            <ion-input label="Közlekedési eszköz{{ cs('utazas_eszkoz') }}" label-placement="stacked" fill="outline"
              placeholder="pl. saját gépkocsi" maxlength="120" formControlName="utazas_eszkoz"></ion-input>
          </ion-col>
          <ion-col size="12" size-md="2">
            <ion-input label="Rendszám{{ cs('utazas_rendszam') }}" label-placement="stacked" fill="outline"
              maxlength="20" formControlName="utazas_rendszam"></ion-input>
          </ion-col>
        </ion-row>



        

        <ion-row *ngIf="segment=='4'">
          <ion-col size="12">
            <!--  A BELÉPÉS ITT DŐL EL. Korábban ezen a fülön egy nem működő KAS-űrlap
                  állt (letiltott mezők, kötés nélkül) – a fiókot a Keycloak admin
                  felületén kellett kézzel megcsinálni, és a szerkesztőben sehol nem
                  látszott, van-e egyáltalán. -->
            <app-belepes-fiok fajta="dolgozo"
                              [azonosito]="activeAllomany?.adid || ''"
                              [nev]="(activeAllomany?.viselt_vez || '') + ' ' + (activeAllomany?.viselt_ker || '')">
            </app-belepes-fiok>
          </ion-col>
        </ion-row>
        



        <ion-row *ngIf="segment=='5'">
          <ion-col>
            <ion-card color="primary">
              <ion-card-header>
                <ion-card-title>Végzettségek importálása</ion-card-title>
                <ion-card-subtitle style="text-align: justify;">Az oktatási mérföldkövek szolgáltatással lehetőség van az adott munkatárs vagy tanuló teljes életútját importálni. Ehhez a felhasználónak rendelkeznie kell a szolgáltatással (merfoldkovek.oh.gov.hu). A Sulinform rendszerébe belépve ezek után lehetősége lesz a felhasználónak importálnia adatait. Ezzel az importált adatok azonnal megbízhatónak lesznek titulálva a forrásuk miatt.</ion-card-subtitle>
              </ion-card-header>
            
            </ion-card>

            <div style="margin-top: 10px;">
              <ion-button color="primary" id="uzenet">
                <ion-icon slot="start" name="add"></ion-icon>
                Új
              </ion-button>
            </div>
            <ng-container>
              <ngx-datatable  (select)="onSelect($event)"
                class="ngx-datatable cronomitnew fixed-header fixed-row virtualized scroll-horz"
                [rows]="allomany" [sortType]="SortType.single" [columnMode]="ColumnMode.force" [limit]="10"
                 [rowClass]="getRowClass" [sorts]="[
        { prop: 'created_at', dir: 'desc' },
        { prop: 'updated_at', dir: 'desc' },
        { prop: 'priority', dir: 'desc' },
        { prop: 'deadline', dir: 'desc' }
      ]" [messages]="{emptyMessage: 'Nincs megjeleníthető adat!'}">
                <ngx-datatable-column name="Név" prop="Típus">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Típus</b>
                    {{ row.viselt_vez }} {{ row.viselt_ker }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Ország">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Ország</b>
      
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Irsz." prop="szul_hely">
                  <ng-template let-value="value" ngx-datatable-cell-template>
                    <b class="mobil">Irsz.</b>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Helység" prop="oktazon">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Helység</b>
                    <span *ngIf="value">{{ value }}</span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Cím" prop="adid">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Cím</b>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Alapértelmezett" prop="adid">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Alapértelmezett</b>
                    {{ value }}
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Műveletek">
                  <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <b class="mobil">Műveletek</b>
                    <ion-button color="secondary" size="small" style="margin-top:0">
                      <ion-icon slot="icon-only" name="create"></ion-icon>
      
                    </ion-button>
                    <ion-button color="danger" size="small" style="margin-top:0">
                      <ion-icon slot="icon-only" name="trash"></ion-icon>
      
                    </ion-button>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ng-container>
          </ion-col>
        </ion-row>





      </ion-grid>
    </form>

    </ion-content>
  </ng-template>
</ion-modal>
